var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPalette({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.022,22a10.017,10.017,0,0,0,9.929-8.632,4.828,4.828,0,0,0-.47-2.895C18.738,5.26,11.019,12.475,11.02,6c0-2.794,0-4-2-4C4,2,2,7.694,2,12A10.011,10.011,0,0,0,12.022,22ZM15.5,12A2.5,2.5,0,1,1,13,14.5,2.5,2.5,0,0,1,15.5,12ZM9,16.5A1.5,1.5,0,1,1,7.5,15,1.5,1.5,0,0,1,9,16.5ZM6.5,6A1.5,1.5,0,1,1,5,7.5,1.5,1.5,0,0,1,6.5,6Zm-1,4.5A1.5,1.5,0,1,1,4,12,1.5,1.5,0,0,1,5.5,10.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalette);
export default __webpack_public_path__ + "static/media/palette.3f5bf167d5274cabeca1dcc19240338d.svg";
export { ForwardRef as ReactComponent };